export default {
    title: {
        register: 'ลงทะเบียน',
        termsAndCond: "ข้อกำหนดและเงื่อนไข",
        privacy: "ข้อมูลส่วนบุคคล",
        marketing: "ความยินยอมเพื่อวัตถุประสงค์ทางการตลาด"
    },
    body: {
        fillEng: "กรุณาระบุข้อมูลเป็นภาษาอังกฤษ",
        iAgree: "ฉันยอมรับใน <span class='label-terms underline'>เงื่อนไขข้อกำหนด</span> และ <span class='label-privacy  underline'>นโยบายทางด้านข้อมูลส่วนบุคคล</span>",
        term: "ฉันยอมรับใน <span class='label-terms underline'>ข้อกำหนดและเงื่อนไข</span>",
        privacy: "ฉันยอมรับใน <span class='label-privacy underline'>นโยบายทางด้านข้อมูลส่วนบุคคล</span>",
        marketing: "ฉันยอมรับใน <span class='label-marketing underline'>วัตถุประสงค์ทางการตลาด</span>",
        mkt_title: "Allow channel to marketing message, <br /> please select at least 1 channel.",
        mkt_all: "ทั้งหมด",
        mkt_email: "Email",
        mkt_sms: "SMS / Phone",
        mkt_noti: "Notification",
    },
    bottomSheet: {
        txtSuccess: "ลงทะเบียน <br /> JCB Thailand สำเร็จแล้ว",
        txtConnecting: "Connecting ..."
    },
    buttons: {
        register: 'ลงทะเบียน',
        accept: 'ยอมรับ',
        unaccept: 'ไม่ยอมรับ'
    },
    form: {
        firstName: {
            name: 'ชื่อ *',
            placeholder: '',
            required: 'กรุณาระบุชื่อ',
            onlyEng: 'กรุณาระบุข้อมูลเป็นภาษาอังกฤษ',
            too_short: '',
            invalid: '',
        },
        lastName: {
            name: 'นามสกุล *',
            placeholder: '',
            required: 'กรุณาระบุนามสกุล',
            onlyEng: 'กรุณาระบุข้อมูลเป็นภาษาอังกฤษ',
            too_short: '',
            invalid: '',
        },
        dateOfBirth: {
            name: 'วันเกิด *',
            placeholder: '',
            required: 'กรุณาระบุวันเกิด',
            too_short: '',
            invalid: '',
            date: 'วว',
            month: 'ดด',
            year: 'ปปปป',
        },
        gender: {
            name: "เพศ *",
            required: "กรุณาระบุเพศ",
            labels: {
                male: "ชาย",
                female: "หญิง",
                none: "ไม่ระบุ"
            }
        },
        email: {
            name: 'อีเมล *',
            placeholder: '',
            required: 'กรุณาระบุอีเมล',
            too_short: '',
            invalid: 'รูปแบบอีเมลไม่ถูกต้อง',
        },
        mobileNo: {
            name: 'หมายเลขโทรศัพท์มือถือ *',
            placeholder: '',
            required: 'กรุณาระบุหมายเลขโทรศัพท์มือถือ',
            too_short: '',
            invalid: '',
        },
        countryName: {
            name: 'ประเทศ',
            placeholder: '',
            required: 'กรุณาระบุประเทศ',
            too_short: '',
            invalid: '',
        },
        provinceName: {
            name: 'จังหวัด',
            placeholder: '',
            required: 'กรุณาระบุจังหวัด',
            too_short: '',
            invalid: '',
        }
    },
    errUnder18: "ขออภัย คุณไม่สามารถลงทะเบียนได้ เนื่องจากอายุไม่ถึง 18 ปี",
    errPhoneNumberDuplicated: "ขออภัยค่ะ หมายเลยโทรศัพท์ของท่านมีอยู่แล้วในระบบ กรุณาตรวจสอบอีกครั้ง",
    errLineDuplicated: "บัญชีไลน์นี้ ได้ทำการลงทะเบียนไว้แล้วด้วยหมายเลขโทรศัพท์อื่น กรุณาตรวจสอบอีกครั้ง",
    errEmailDuplicated: "ขออภัยค่ะ อีเมล์ของท่านมีอยู่แล้วในระบบ กรุณาตรวจสอบอีกครั้ง",
}
